import {
  AppLogger,
  DynatraceClient,
  LogTypes,
} from '@workivate/tho-web-shared';
import { IS_PRODUCTION } from 'utils/check-environment/check-environment';
import { initialiseDynatrace, loadDynatraceScript } from './dynatrace-helpers';

/**
 * Loads the Dynatrace script, initialises DynatraceClient, and wires AppLogger
 * to route logs to Dynatrace as events/exceptions.
 *
 * Must be called after getCorrelationId() so the correct correlation ID is
 * already in localStorage when DynatraceClient.init() reads it.
 */
export const setupDynatrace = async (scriptUrl: string): Promise<void> => {
  await loadDynatraceScript(scriptUrl);
  initialiseDynatrace();
  AppLogger.configure({
    isProduction: IS_PRODUCTION,
    dynatraceLogger: (message, context = {}) => {
      if (context['error']) {
        DynatraceClient.sendException(new Error(context['error']), {
          logmessage: message,
          ...(context['loglevel'] && { loglevel: context['loglevel'] }),
        });
      }

      DynatraceClient.sendEvent('frontend.log', {
        logmessage: message,
        ...(context['loglevel'] && { loglevel: context['loglevel'] }),
      });
    },
  });

  // usl has no debug overlay (yet) surface Dynatrace session id via appLogger
  const dtSessionId = DynatraceClient.getSessionId();
  if (dtSessionId) {
    const dtSessionUrl =
      'https://hmn06273.apps.dynatrace.com/ui/apps/dynatrace.users.sessions' +
      `/session-viewer/${dtSessionId}/${new Date().toISOString()}` +
      '?perspective=general&tf=now-8h%3Bnow';

    AppLogger.logWithOptions({
      message: 'Dynatrace session started',
      level: LogTypes.Info,
      context: { dtSessionId, dtSessionUrl },
    });
  }
};
